import createHost from 'cross-domain-storage/host'

/**
 * @function  crossDomainStorage
 * Функция, которая организовывает работу с localstorage для других сайтов платформы.
 * */
export function crossDomainStorage() {

    var storageHost = createHost([
        {
            origin: 'https://doc.profdoctor.net',
            allowedMethods: ['get'],
        }, {
            origin: 'https://dev.profdoctor.net',
            allowedMethods: ['get'],
        }, {
            origin: 'https://profdoctor.net',
            allowedMethods: ['get'],
        },
    ]);

}